export const INITIALIZE_INTRANET = "initializeIntranet";
export const RELOAD_CURRENT_INTRANET = "reloadCurrentIntranet";
export const LOAD_AVAILABLE_INTRANETS = "loadingAvailableIntranets";
export const LOAD_PERMISSION_FOR_CURRENT_INTRANET = "loadingPermissionForCurrentIntranet";
export const UPDATE_INTRANET = "updateIntranet";
export const UPDATE_DOMAIN_INTRANET_ACCESS = "updateDomainIntranetAccess";
export const RESET_INTRANETS = "resetIntranets";
export const UPDATE_INTRANET_TEAM_COUNT = "update-intranet-team-count";
export const TOGGLE_FEATURE = "toggleFeature";
